export default __webpack_public_path__ + "static/Ico_agotado-e2c3bc82fb2eab710e9c0875f85373a3.png";